import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import s from './lightbox.scss';

class Lightbox extends React.Component {

  closeModal = () => {
    this.props.closeLightbox();
  }

  render() {
    const imgAddr = `${process.env.GEOSERVER}/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&LAYER=${this.props.district.prefix}:${this.props.layerName}`;

    return (
      <div id="legendModal" className="legend">
        <span className="closeLegend" onClick={this.closeModal}>&times;</span>
        <span className="zoom-in" onClick={this.closeModal}>&times;</span>
        <div className="modal-content">

          <div className="legendSlide">
            {this.props.district.prefix === 'krosno' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/upload/legenda_krosno_plan.png`} role="presentation" /> : null }
            {this.props.district.prefix === 'gmina_cieszanow' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/upload/legenda_gmina_cieszanow_plan.png`} role="presentation" /> : null}
            {this.props.district.prefix === 'gmina_zarow' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/static/legenda_cmentarz.png`} role="presentation" /> : null}
            {this.props.district.prefix === 'swiebodzice' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/static/legenda_cmentarz.png`} role="presentation" /> : null}
            {this.props.district.prefix === 'gmina_siekierczyn' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/static/legenda_cmentarz.png`} role="presentation" /> : null}
            {this.props.district.prefix === 'gmina_strzegom' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/static/legenda_cmentarz.png`} role="presentation" /> : null}
            {this.props.district.prefix === 'gmina_swierzawa' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/static/legenda_cmentarz.png`} role="presentation" /> : null}
            {this.props.district.prefix === 'jawor' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/static/legenda_cmentarz.png`} role="presentation" /> : null}
            
          </div>

        </div>
      </div>
    );
  }
}

const mapState = state => ({
  district: state.district.district,
});

export default withStyles(s)(connect(mapState)(Lightbox));



// WEBPACK FOOTER //
// src/components/Modals/LayersModal/Lightbox.js